import "@aitisal/ui/styles";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./App.css";

import { AitisalSdk } from "@aitisal/sdk";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { registerSW } from "virtual:pwa-register";
import axiosInstance from "../apis/index";
import ToastWindow from "./components/ToastWindow";
import { AnalyticsProvider } from "./providers/AnalyticsProvider";
import { routeTree } from "./routeTree.gen";
import { ThemeProvider } from "./themes/ThemeProvider";

const queryClient = new QueryClient();

AitisalSdk.configure(axiosInstance);

const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultViewTransition: true,
  scrollRestoration: true,
  notFoundMode: "root",
});

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider>
          <ToastWindow>
            <RouterProvider router={router} />
          </ToastWindow>
        </AnalyticsProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);

registerSW({
  onOfflineReady() {
    console.log("App ready for offline use");
  },
});
